'use client';

import { useEffect } from 'react';
import { useCartStore } from 'stores/cart';

interface SyncShoppingCartArticleCountProps {
  count: number;
}

/**
 * SyncShoppingCartArticleCount - Writes the server-side cart article count into the cart store.
 *
 * The header cart icon (ShoppingCartStreaming) is not rendered on cart step pages, so nothing
 * else fills `mainArticleCount` there and it stays at the store default of 0.
 *
 * The cart page re-renders with fresh articles after a mutation (e.g. an express product add
 * revalidates the cart tags), so the new `count` prop re-runs the effect and keeps the store in sync.
 */
export function SyncShoppingCartArticleCount({ count }: SyncShoppingCartArticleCountProps) {
  const setMainArticleCount = useCartStore(s => s.setMainArticleCount);

  useEffect(() => {
    setMainArticleCount(count);
  }, [count, setMainArticleCount]);

  return null;
}
